import React, { useState } from 'react';
import { Menu, Transition } from '@headlessui/react';

interface DropdownProps {
    alignment?: DropdownAlignment;
    customAlignmentClassName?: string;
    contentContainerClassName?: string;
    className?: string;
    triggerElement: React.ReactNode;
    children: React.ReactNode;
}

export enum DropdownAlignment {
    Left = 'left',
    Right = 'right',
    Top = 'top',
    Bottom = 'bottom',
}

const Dropdown = ({
    alignment = DropdownAlignment.Right,
    customAlignmentClassName,
    contentContainerClassName = '',
    className = '',
    triggerElement,
    children,
}: DropdownProps) => {
    let alignmentClasses: string = customAlignmentClassName ?? '';

    if (!alignmentClasses) {
        switch (alignment) {
            case DropdownAlignment.Left:
                alignmentClasses = 'origin-top-left left-0';
                break;
            case DropdownAlignment.Right:
                alignmentClasses = 'origin-top-right right-0';
                break;
            case DropdownAlignment.Top:
                alignmentClasses = 'origin-top';
                break;
            case DropdownAlignment.Bottom:
                alignmentClasses = 'origin-bottom bottom-0 -right-1/2';
                break;
        }
    }

    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <Menu
            as="div"
            className={`${className} ${isOpen ? 'relative z-200' : ''}`}
        >
            {({ open }) => {
                setTimeout(() => setIsOpen(open), 20);
                return (
                    <>
                        <Menu.Button as={React.Fragment}>
                            {triggerElement}
                        </Menu.Button>

                        <Transition
                            as="div"
                            show={open}
                            enter="transition ease-out duration-200"
                            enterFrom="transform opacity-0 scale-50"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95 z-200"
                        >
                            <div
                                className={`absolute z-200 mt-2 rounded-lg shadow-lg ${alignmentClasses}`}
                            >
                                <Menu.Items
                                    className={`rounded-lg bg-white p-1 text-black ring-1 ring-slate-200 focus:outline-none ${contentContainerClassName}`}
                                    static
                                >
                                    {children}
                                </Menu.Items>
                            </div>
                        </Transition>
                    </>
                );
            }}
        </Menu>
    );
};

export default Dropdown;
